import type { ReactNode } from "react";
import { Menu as M } from "@headlessui/react";
import {
  AiChat02Icon,
  CustomerSupportIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { useAuthContext } from "providers/Auth";
import { NavLink } from "providers/Layout/components/NavLink";
import { NewBadge } from "shared/app/NewBadge";
import { useMessagePopupStore } from "shared/app/MessagePopup/store";
import { Show } from "shared/components/helpers/Show";
import { useOpenSupportChat } from "shared/hooks/use-open-support-chat";
import {
  useLocalStorage,
  writeLocalStorage
} from "shared/hooks/use-local-storage";
import { BOOM_HELP_COPY, boomHelpSeenKey } from "../constants";
import { useBoomHelpStore } from "../store";

const HELP_ROW_CLASS = "px-4 !gap-3 border-b border-alpha-40 !items-start";

const HelpMenuItem = ({
  title,
  description,
  badge
}: {
  title: string;
  description: string;
  badge?: ReactNode;
}) => (
  <span className="flex min-w-0 flex-col items-start whitespace-normal break-normal text-left">
    <span className="flex items-center gap-2">
      <span className="text-base font-medium text-content-1000">{title}</span>
      {badge}
    </span>
    <span className="text-xs font-medium text-content-300">{description}</span>
  </span>
);

export const HelpMenuSection = () => {
  const { auth } = useAuthContext();
  const openSupportChat = useOpenSupportChat("boom_help_message_support");
  const seenKey = boomHelpSeenKey(auth?.id);
  const seen = useLocalStorage(seenKey) !== null;

  const askBoomHelp = () => {
    writeLocalStorage(seenKey, "1");
    useMessagePopupStore.getState().close();
    useBoomHelpStore.getState().open();
  };

  return (
    <>
      <M.Item>
        <NavLink
          HugeIcon={AiChat02Icon}
          className={HELP_ROW_CLASS}
          onClick={askBoomHelp}
        >
          <HelpMenuItem
            title={BOOM_HELP_COPY.askTitle}
            description={BOOM_HELP_COPY.askDescription}
            badge={
              <Show if={!seen}>
                <NewBadge />
              </Show>
            }
          />
        </NavLink>
      </M.Item>
      <M.Item>
        <NavLink
          HugeIcon={CustomerSupportIcon}
          className={HELP_ROW_CLASS}
          onClick={openSupportChat}
        >
          <HelpMenuItem
            title={BOOM_HELP_COPY.supportTitle}
            description={BOOM_HELP_COPY.supportDescription}
          />
        </NavLink>
      </M.Item>
    </>
  );
};
